export const qrAssetsPath = (quantity: string): string => {
  return `/assets/generate-qr-codes/${quantity}`
}
